import React from 'react';
import { ApplicationTable, Application } from '../../components/ApplicationTable';
// Mock Data Generator
const generateMockApplications = (): Application[] => {
  const statuses = ['Pending Approval', 'Inactive', 'Accepted', 'Rejected', 'Cooling Off Period', 'Withdrawn', 'Disbursement Ready', 'Active', 'Settled'] as const;
  const mechanisms = ['STP', 'Validation'] as const;
  const stages = ['Completed', 'Maker', 'Checker', 'Approver'] as const;
  return Array.from({
    length: 20
  }).map((_, i) => {
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const loanAmount = Math.floor(Math.random() * 95000) + 5000;
    const principalAmount = Math.floor(loanAmount * 0.95);
    const interest = Math.floor(loanAmount * 0.15);
    const fees = Math.floor(Math.random() * 1000) + 100;
    const totalRepayment = principalAmount + interest + fees;
    // Cooling-off period logic: only for "Cooling Off Period" status
    const coolingOffTotal = status === 'Cooling Off Period' ? 336 : 0; // 14 days = 336 hours
    const coolingOffRemaining = status === 'Cooling Off Period' ? Math.floor(Math.random() * 336) : 0;
    return {
      id: `APP-2024-${String(i + 1).padStart(3, '0')}`,
      productId: `PL-${String(Math.floor(Math.random() * 5) + 1).padStart(3, '0')}`,
      merchantId: `MCH-${String(Math.floor(Math.random() * 10000) + 10000)}`,
      merchantName: `Merchant ${String.fromCharCode(65 + i)} Electronics`,
      loanAmount,
      loanTenor: [12, 24, 36, 48, 60][Math.floor(Math.random() * 5)],
      status,
      mechanism: mechanisms[Math.floor(Math.random() * mechanisms.length)],
      mechanismStage: stages[Math.floor(Math.random() * stages.length)],
      principalAmount,
      totalRepayment,
      interest,
      apr: Number((Math.random() * 15 + 5).toFixed(2)),
      fees,
      coolingOffTotal,
      coolingOffRemaining,
      merchantType: Math.random() > 0.5 ? 'New' : 'Partner',
      partnerType: Math.random() > 0.5 ? 'Tapsys' : 'Direct',
      date: new Date(Date.now() - Math.floor(Math.random() * 10000000000)).toISOString().split('T')[0]
    };
  });
};
export const mockApplications = generateMockApplications();
interface MasterViewProps {
  onNavigateToDetail: (appId: string) => void;
  applicationStatuses?: Record<string, {
    status: string;
    logs: Array<any>;
  }>;
}
export function MasterView({
  onNavigateToDetail,
  applicationStatuses = {}
}: MasterViewProps) {
  const getStatusBadge = (status: string) => {
    const statusMap: Record<string, {
      bg: string;
      text: string;
    }> = {
      'Pending Approval': {
        bg: 'bg-blue-100',
        text: 'text-blue-800'
      },
      'Submitted to Checker': {
        bg: 'bg-purple-100',
        text: 'text-purple-800'
      },
      Accepted: {
        bg: 'bg-green-100',
        text: 'text-green-800'
      },
      Rejected: {
        bg: 'bg-red-100',
        text: 'text-red-800'
      },
      Inactive: {
        bg: 'bg-gray-100',
        text: 'text-gray-800'
      },
      'Cooling Off': {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800'
      },
      Withdrawn: {
        bg: 'bg-orange-100',
        text: 'text-orange-800'
      },
      'Disbursement Ready': {
        bg: 'bg-teal-100',
        text: 'text-teal-800'
      },
      Active: {
        bg: 'bg-indigo-100',
        text: 'text-indigo-800'
      },
      Settled: {
        bg: 'bg-emerald-100',
        text: 'text-emerald-800'
      }
    };
    const style = statusMap[status] || {
      bg: 'bg-gray-100',
      text: 'text-gray-800'
    };
    return `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style.bg} ${style.text}`;
  };
  const data = mockApplications.map(app => ({
    ...app,
    status: applicationStatuses[app.id]?.status || app.status
  }));
  return <ApplicationTable title="Master Application View" applications={data} onApplicationClick={app => onNavigateToDetail(app.id)} data-id="element-1593" />;
}